/**************************************************
 * Nombre:       Tarjeta_Coleccion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useNavigate} from "react-router";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Tarjeta_Coleccion = ({item}) => {
    const {sCell, masSM} = useResponsive()
    const navigate = useNavigate();

    return (
        <Grid
            onClick={() => navigate("/DetalleCol/" + item.id)}
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundImage: `linear-gradient(305deg, rgba(0, 0, 0, 0.67) 3.12%, rgba(102, 102, 102, 0.00) 51.49%), url(${item.img})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat',
                p: 4,
                cursor: 'pointer',
            }}

        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', mt: !masSM ? 18 : 40}}>
                <Typography
                    sx={{
                        color: '#fff',
                        fontSize: 16,
                        borderBottom: 1,
                        borderColor: '#fff',
                        cursor: 'pointer'
                    }}>{item.nombre}</Typography>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Coleccion